export type GamificationSettings = {
  expense_deadline_day?: number;
  is_gamification_enabled?: boolean;
};

export type MileageRateMode =
  "NOTACITO_DEFAULT" | "CUSTOM_WITH_FALLBACK" | "CUSTOM_ONLY";

export type MileageRateSettings = {
  mileage_rate_mode: MileageRateMode;
};

export type VehicleType = "CAR" | "MOTORBIKE" | "MOPED";
export type EnergyType = "ELECTRIC" | "THERMAL" | "HYBRID" | "HYDROGEN";
export type SelectableEnergyType = "THERMAL" | "ELECTRIC";

export type MileageRate = {
  uuid?: string;
  year: number;
  vehicle_type: VehicleType;
  energy_type?: EnergyType | null;
  power_cv_min: number;
  power_cv_max: number;
  distance_min: number;
  distance_max: number;
  fixed_amount: number;
  per_km_amount: number;
  is_active: boolean;
  company_uuid?: string | null;
};

export type RateFormErrors = Partial<Record<keyof MileageRate, string>>;

export const VEHICLE_TYPES: VehicleType[] = ["CAR", "MOTORBIKE", "MOPED"];
export const SELECTABLE_ENERGY_TYPES: SelectableEnergyType[] = [
  "THERMAL",
  "ELECTRIC",
];
